import { TechStackItem } from "@/components/TechStackTicker";

// Icons are self-hosted from devicon (MIT) in public/tech/devicon — not loaded
// from cdn.jsdelivr.net/@latest at runtime (SEO spec 3.5).

export const DEFAULT_TECH_STACK: TechStackItem[] = [

  {
    id: "ai-pytorch",
    name: "PyTorch",
    iconUrl: "/tech/devicon/pytorch-original.svg",
  },
  {
    id: "ai-tensorflow",
    name: "TensorFlow",
    iconUrl: "/tech/devicon/tensorflow-original.svg",
  },

  {
    id: "auto-playwright",
    name: "Playwright",
    iconUrl: "/tech/devicon/playwright-original.svg",
  },
  {
    id: "auto-selenium",
    name: "Selenium",
    iconUrl: "/tech/devicon/selenium-original.svg",
  },
  {
    id: "auto-puppeteer",
    name: "Puppeteer",
    iconUrl: "/tech/devicon/puppeteer-original.svg",
  },
 

  // --- Frontend & Mobile Frameworks ---
  {
    id: "fe-react",
    name: "React",
    iconUrl: "/tech/devicon/react-original.svg",
  },
  {
    id: "fe-nextjs",
    name: "Next.js",
    iconUrl: "/tech/devicon/nextjs-original.svg",
  },
  {
    id: "fe-typescript",
    name: "TypeScript",
    iconUrl: "/tech/devicon/typescript-original.svg",
  },
  {
    id: "fe-tailwind",
    name: "Tailwind CSS",
    iconUrl: "/tech/devicon/tailwindcss-original.svg",
  },
  {
    id: "fe-reactnative",
    name: "React Native",
    iconUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
  },
  {
    id: "fe-flutter",
    name: "Flutter",
    iconUrl: "/tech/devicon/flutter-original.svg",
  },
  {
    id: "fe-vue",
    name: "Vue.js",
    iconUrl: "/tech/devicon/vuejs-original.svg",
  },

  // --- Backend, Cloud & DevOps ---
  {
    id: "be-python",
    name: "Python",
    iconUrl: "/tech/devicon/python-original.svg",
  },
  {
    id: "be-nodejs",
    name: "Node.js",
    iconUrl: "/tech/devicon/nodejs-original.svg",
  },
  {
    id: "be-fastapi",
    name: "FastAPI",
    iconUrl: "/tech/devicon/fastapi-original.svg",
  },
  {
    id: "be-golang",
    name: "Go (Golang)",
    iconUrl: "/tech/devicon/go-original.svg",
  },
  {
    id: "be-postgres",
    name: "PostgreSQL",
    iconUrl: "/tech/devicon/postgresql-original.svg",
  },
  {
    id: "be-redis",
    name: "Redis",
    iconUrl: "/tech/devicon/redis-original.svg",
  },
  {
    id: "be-supabase",
    name: "Supabase",
    iconUrl: "/tech/devicon/supabase-original.svg",
  },
  {
    id: "be-mongodb",
    name: "MongoDB",
    iconUrl: "/tech/devicon/mongodb-original.svg",
  },
  {
    id: "dev-docker",
    name: "Docker",
    iconUrl: "/tech/devicon/docker-original.svg",
  },
  {
    id: "dev-k8s",
    name: "Kubernetes",
    iconUrl: "/tech/devicon/kubernetes-plain.svg",
  },
  {
    id: "cloud-aws",
    name: "AWS",
    iconUrl: "/tech/devicon/amazonwebservices-original-wordmark.svg",
  },
  {
    id: "cloud-gcp",
    name: "Google Cloud",
    iconUrl: "/tech/devicon/googlecloud-original.svg",
  },
  {
    id: "cloud-azure",
    name: "Microsoft Azure",
    iconUrl: "/tech/devicon/azure-original.svg",
  },
  {
    id: "cloud-cloudflare",
    name: "Cloudflare",
    iconUrl: "/tech/devicon/cloudflare-original.svg",
  }

];
